import React, { useState } from 'react'
import s from './ThisDayInfo.module.scss'
import cloud from '../../Assets/images/cloud.png'
import { ThisDayItem } from './ThisDayItem'
import { Weather } from '../../store/types/types';

interface Props {
  weather: Weather;
}

export interface Item{
  icon_id: string;
  nameInfo: string;
  value: string;
}

export const ThisDayInfo = ({weather}: Props) => {

  let test:string = "Чистое небо"
  switch (weather.weather[0].main) {
    case "Clouds":
       test = "Облачно"
      break;
    case "Rain":
      test ="Дождь"
      break;
    case "Thunderstorm":
      test = "Гроза"
      break;
    case "Drizzle":
      test = "Мелкий дождь"
      break;
    case "Snow":
      test = "Снег"
      break;
    case "Clear":
      test =  "Чистое небе"
      break;
    case "Mist":
    case "Smoke":
    case "Haze":
    case "Dust":
    case "Fog":
    case "Ash":
    case "Squall":
    case "Tornado":
      test =  "Чистое небе" 
      break;
    default:
      break;
  }
  const items = [
    {
      icon_id: 'temp',
      nameInfo: 'Температура',
      value: `${Math.floor(weather.main.temp)}° - ощущается как ${weather.main.feels_like}°`,
    },
    {
      icon_id: 'pressure',
      nameInfo: 'Давление',
      value: `${weather.main.pressure} мм ртутного столба`,
    },
    {
      icon_id: 'precipitation',
      nameInfo: 'Осадки',
      value: `${test}`,
    },
    {
      icon_id: 'wind',
      nameInfo: 'Ветер',
      value: `${weather.wind.speed} м/с`,
    }
  ]

  return (
    <div className={s.this__day_info}>
        <div className={s.this__day_info_items}>
          {items.map((item: Item) => (
          <ThisDayItem key={item.icon_id} item={item} />
        ))}
        </div>
        <img className={s.cloud__img} src={cloud} alt="cloud" />
    </div>
  )
}